import React from 'react';
import { useApp } from '../context/AppContext';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useApp();

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 w-full max-w-sm pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          // An alert toast is a button: tapping it goes where the event lives
          // (the group, the order chat, the Text Inbox thread) and dismisses.
          role={toast.onClick ? 'button' : undefined}
          tabIndex={toast.onClick ? 0 : undefined}
          onClick={toast.onClick ? () => { toast.onClick?.(); removeToast(toast.id); } : undefined}
          onKeyDown={toast.onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toast.onClick?.(); removeToast(toast.id); } } : undefined}
          className={`pointer-events-auto flex items-start p-4 rounded-lg shadow-lg border animate-in slide-in-from-right fade-in duration-300 ${toast.onClick ? 'cursor-pointer hover:bg-slate-50' : ''} ${
            toast.type === 'success' ? 'bg-white border-green-200 text-slate-800' :
            toast.type === 'error' ? 'bg-white border-red-200 text-slate-800' :
            'bg-white border-blue-200 text-slate-800'
          }`}
        >
          <div className="shrink-0 mr-3 mt-0.5">
            {toast.type === 'success' && <CheckCircle className="text-green-500" size={20} />}
            {toast.type === 'error' && <AlertCircle className="text-red-500" size={20} />}
            {toast.type === 'info' && <Info className="text-blue-500" size={20} />}
          </div>
          <div className="flex-1 mr-2">
            <h4 className={`text-sm font-bold ${
               toast.type === 'success' ? 'text-green-700' :
               toast.type === 'error' ? 'text-red-700' :
               'text-blue-700'
            }`}>
              {toast.title ?? (toast.type === 'success' ? 'Success' : toast.type === 'error' ? 'Error' : 'Info')}
            </h4>
            <p className="text-sm text-slate-600 leading-relaxed">{toast.message}</p>
          </div>
          <button 
            onClick={(e) => { e.stopPropagation(); removeToast(toast.id); }}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};